import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SnackbarService } from '@services/snackbar/snackbar.service';
import { Services } from '@ibexfusion/core-utils';
import { Models } from '@ibexfusion/models';

import { PageAction } from '../../../components/page-actions/page-actions.component';
import { CompositionService } from '@services/compositions/composition.service';
import { CompositionTypeService } from '@services/composition-types/composition-type.service';
import { CompositionAppService } from '@services/compositions/composition-app.service';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { OrganisationService } from '@services/organisations/organisation.service';
import { OrganisationCustomerService } from '@services/customers/organisation-customer.service';
import * as _ from 'lodash';

@Component({
    selector: 'app-composition-wizard',
    templateUrl: 'composition-wizard.component.html',
    styleUrls: ['composition-wizard.component.scss'],
    providers: [CompositionService, CompositionTypeService, CompositionAppService, DynamicContentEntranceService, OrganisationService, OrganisationCustomerService],
    standalone: false
})
export class CompositionWizardComponent implements OnInit {

  public title = 'Composition wizard';

  public pageActions: PageAction[] = [];

  public isLoading: boolean;

  public composition: Models.Composition;

  public compositionTypes: Models.CompositionType[];

  public isCopy = false;
  public organisations: Models.Organisation[];
  public orgCustomers: Models.OrganisationCustomer[];
  private copiedFrom;
  private organisationId;
  private customerId;

  constructor(
    private compositionService: CompositionService,
    private compositionTypeService: CompositionTypeService,
    private compositionAppService: CompositionAppService,
    private dynamicContentEntranceService: DynamicContentEntranceService,
    private orgService: OrganisationService,
    private orgCustomerService: OrganisationCustomerService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private snackbar: SnackbarService
  ) {
  }

  ngOnInit() {
    let compositionId = this.activatedRoute.snapshot.params['id'];
    const compositionTypeId = this.activatedRoute.snapshot.params['typeId'];
    this.isCopy = this.activatedRoute.snapshot.url[0].path === 'copy';
    this.createPageActions();
    if (compositionId) {
      this.title = 'Edit composition';
      this.compositionService.get(compositionId).then(composition => {
        this.copiedFrom = JSON.parse(JSON.stringify(composition));
        this.composition = composition;
        if (this.isCopy) {
          this.title = 'Copy composition';
          delete this.composition._id;
          delete this.composition.title;
          compositionId = null;
          this.getOrganisations().then(result => {
            this.organisations = result;
          })
          this.orgCustomerService.find(0, 1000, { '$sort': { title: 1 } }).then(customers => {
            this.orgCustomers = customers.data;
          });
        }
        this.title += ' ' + composition.title;
      });
    } else {
      this.title = 'New composition';
      this.composition = new Models.Composition();
      this.composition.typeId = compositionTypeId;
    }

    this.compositionTypeService.find(0, 25).then(res => {
      this.compositionTypes = res.data;
    });
  }

  public saveComposition(reload?): void {
    let promise = Promise.resolve(this.composition);

    if (this.composition._id) {
      promise = this.compositionService.update(this.composition._id, this.composition);
    } else {
      promise = this.compositionService.create(this.composition);
    }

    promise.then(composition => {
      if (this.isCopy) {
        this.compositionAppService.find(0, 100, { compositionId: this.copiedFrom._id }).then(apps => {
          for (let i = 0, p = Promise.resolve(); i < apps.data.length; i++) {
            p.then(() => {
              const app = apps.data[i];
              delete app._id;
              app.compositionId = composition._id;
              return this.compositionAppService.create(app);
            });
          }
        });
        if (composition.dynamicContentIds && composition.dynamicContentIds.length) {
          for (let i = 0, p = Promise.resolve(); i < composition.dynamicContentIds.length; i++) {
            p.then(() => {
              return this.dynamicContentEntranceService.get(composition.dynamicContentIds[i]).then(entrance => {
                delete entrance._id;
                entrance.OwnerOrganisationID = Services.HashIdService.hashSingle(this.organisationId ? this.organisationId : entrance.OwnerOrganisationID);
                entrance.OwnerCustomerID = this.customerId ? this.customerId : entrance.OwnerCustomerID;
                entrance.children = [];
                entrance.categories = [];
                return this.dynamicContentEntranceService.create(entrance).then(newEntrance => {
                  composition.dynamicContentIds[i] = newEntrance._id;
                  return this.compositionService.update(composition._id, composition);
                });
              });
            });
          }
        }
      }
      this.composition = composition;
      this.snackbar.success('Composition saved');
      if (reload) {
        this.router.navigate(['compositions', this.composition._id]);
      }
    }, error => {
      this.snackbar.error('Failed');
      console.error(error);
    });
  }

  public setOrganisation(event: any) {
    this.organisationId = Services.HashIdService.unhashSingle(event.value);
  }

  public setCustomer(event: any) {
    this.customerId = event.value;
  }

  private getOrganisations(skip = 0, organisations = []) {
    return this.orgService.find(skip, 100).then(result => {
      organisations = organisations.concat(result.data);
      if (result.data.length === 100) {
        return this.getOrganisations(skip + 100, organisations);
      } else {
        return _.orderBy(organisations, ['title']);
      }
    });
  }

  private createPageActions(): void {

    if (this.activatedRoute.snapshot.params['id']) {
      this.pageActions.push(
        new PageAction({
          icon: 'account_balance',
          title: 'Detail composition',
          callback: () => {
            this.router.navigate(['compositions', this.activatedRoute.snapshot.params['id']]);
          }
        })
      )
    } else if (this.activatedRoute.snapshot.params['typeId']) {
      this.pageActions.push(
        new PageAction({
          icon: 'account_balance',
          title: 'Overview compositions',
          callback: () => {
            this.router.navigate(['composition-types', this.activatedRoute.snapshot.params['typeId']]);
          }
        })
      )
    }
    this.pageActions.push(
      new PageAction({
        icon: 'save',
        title: 'Save composition',
        type: 'action',
        callback: () => {
          this.saveComposition();
        }
      })
    );
  }
}
